import { call, put, takeEvery } from "redux-saga/effects";
import { 
  GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS, 
  GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS, 
  GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS, 
  GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES, 
  GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD, 
  GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS, 
  GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS,
  GET_QUOTE_FUNNELS_SOURCE_STATS 
} from "./actionTypes";
import { getQuoteFunnelsStatsForAdGroupsError, getQuoteFunnelsStatsForAdGroupsSuccess, getQuoteFunnelsStatsForAnalyticsError, getQuoteFunnelsStatsForAnalyticsSuccess, getQuoteFunnelsStatsForCampaignsError, getQuoteFunnelsStatsForCampaignsSuccess, getQuoteFunnelsStatsForCreativesError, getQuoteFunnelsStatsForCreativesSuccess, getQuoteFunnelsStatsForDashboardError, getQuoteFunnelsStatsForDashboardSuccess, getQuoteFunnelsStatsForSourceSettingsError, getQuoteFunnelsStatsForSourceSettingsSuccess, getAggQuoteFunnelsStatsForCampaignsSuccess, getAggQuoteFunnelsStatsForCampaignsError, getQuoteFunnelsSourceStatsError, getQuoteFunnelsSourceStatsSuccess } from "./actions";
import { AppConfiguration } from "config"
import { genericGetRequest, genericGetRequest_2, SfPostRequest } from "helpers/sf_backend_helper";
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils";
import { bsh_getClientUserDetails } from "helpers/sf_browser_storage_helper";

function* onGetQuoteFunnelsStatsForDashboard(payload) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      SfPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/qf_extra_stats`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        brand_id: getCurrentBrandFromLocalStorage()?.id,
        payload: payload
      }
    )
    yield put(getQuoteFunnelsStatsForDashboardSuccess(response, payload.api_type))
  } catch (error) {
    yield put(getQuoteFunnelsStatsForDashboardError(error, payload.api_type))
  }
}

function* onGetQuoteFunnelsStatsForAnalytics(payload) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      SfPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_qf_stats_for_analytics`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        brand_id: getCurrentBrandFromLocalStorage()?.id,
        payload: payload
      }
    )
    yield put(getQuoteFunnelsStatsForAnalyticsSuccess(response))
  } catch (error) {
    yield put(getQuoteFunnelsStatsForAnalyticsError(error))
  }
}

function* onGetQuoteFunnelsStatsForCampaigns(payload) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      SfPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_qf_stats_for_campaigns`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        brand_id: getCurrentBrandFromLocalStorage()?.id,
        payload: payload
      }
    )
    yield put(getQuoteFunnelsStatsForCampaignsSuccess(response))
  } catch (error) {
    yield put(getQuoteFunnelsStatsForCampaignsError(error))
  }
}

function* onGetQuoteFunnelsStatsForAdgroups(payload) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      SfPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_qf_stats_for_adgroups`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        brand_id: getCurrentBrandFromLocalStorage()?.id,
        payload: payload
      }
    )
    yield put(getQuoteFunnelsStatsForAdGroupsSuccess(response))
  } catch (error) {
    yield put(getQuoteFunnelsStatsForAdGroupsError(error))
  }
}

function* onGetQuoteFunnelsStatsForSourceSettings(payload) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      SfPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_qf_stats_for_source_settings`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        brand_id: getCurrentBrandFromLocalStorage()?.id,
        payload: payload
      }
    )
    yield put(getQuoteFunnelsStatsForSourceSettingsSuccess(response))
  } catch (error) {
    yield put(getQuoteFunnelsStatsForSourceSettingsError(error))
  }
}

function* onGetQuoteFunnelsStatsForCreatives(payload) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const response = yield call(
      SfPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_qf_stats_for_creatives`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        brand_id: getCurrentBrandFromLocalStorage()?.id,
        payload: payload
      }
    )
    yield put(getQuoteFunnelsStatsForCreativesSuccess(response))
  } catch (error) {
    yield put(getQuoteFunnelsStatsForCreativesError(error))
  }
}

function* onGetQuoteFunnelSourceStats(action) {
  try {
    let user_auth = localStorage.getItem("authUser")
    const { campaign_id, ...queryParams } = action.payload || {}
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v4/campaigns/${campaign_id}/source_stats/quote_funnels`,
      queryParams,
      {
        Authorization: JSON.parse(user_auth).user.token,
        "account-id": JSON.parse(user_auth).user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getQuoteFunnelsSourceStatsSuccess(response))
  } catch (error) {
    yield put(getQuoteFunnelsSourceStatsError(error))
  }
}

// V4 API Saga Function for Campaign Aggregated Data
function* onGetAggQuoteFunnelsStatsForCampaigns(action) {
  try {    
    let user_auth = bsh_getClientUserDetails() 
    const currentBrand = getCurrentBrandFromLocalStorage()
    
    // Call the production v4 API endpoint
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v4/campaign_stats/quote_funnels`,
      {
        start_date: action.payload.start_date,
        end_date: action.payload.end_date
      },
      {
        Authorization: user_auth.token,
        account_id: user_auth.account_id,
        brand_id: currentBrand?.id,
        payload: action.payload
      }
    )
    
    yield put(getAggQuoteFunnelsStatsForCampaignsSuccess(response.data))
  } catch (error) {    
    yield put(getAggQuoteFunnelsStatsForCampaignsError(error))
  }
}

function* QuoteFunnelsStatsSaga() {
  yield takeEvery(GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD, onGetQuoteFunnelsStatsForDashboard);
  yield takeEvery(GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS, onGetQuoteFunnelsStatsForAnalytics);
  yield takeEvery(GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS, onGetQuoteFunnelsStatsForCampaigns);
  yield takeEvery(GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS, onGetQuoteFunnelsStatsForAdgroups);
  yield takeEvery(GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS, onGetQuoteFunnelsStatsForSourceSettings);
  yield takeEvery(GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES, onGetQuoteFunnelsStatsForCreatives);
  yield takeEvery(GET_QUOTE_FUNNELS_SOURCE_STATS, onGetQuoteFunnelSourceStats);
  yield takeEvery(GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS, onGetAggQuoteFunnelsStatsForCampaigns);
}

export default QuoteFunnelsStatsSaga;
